import React from 'react';
import { createRoot } from 'react-dom/client';
import { BreedingWorkflow } from './pages/BreedingWorkflow';
import { FeedbackWidget } from '@shared/components/FeedbackWidget';
import { initConsoleInterceptor } from '@shared/utils/consoleInterceptor';
import { initApiInterceptor } from '@shared/utils/apiInterceptor';
import './styles.css';

// Initialize interceptors for feedback system
initConsoleInterceptor();
initApiInterceptor();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <>
      <BreedingWorkflow />
      <FeedbackWidget />
    </>
  </React.StrictMode>
);
